// ================================================================================================
import * as React from "react";
import "./PrimitiveCss.less";
// ================================================================================================
export interface FloatingActionButtonProps {
    diameter: number;
    backgroundColor: string;
    iconColor?: string;
    onClick?: React.MouseEventHandler<any>;
    onMouseDown?: React.MouseEventHandler<any>;
    style?: React.CSSProperties;
}
// -------------------------------------------------------------------------------------------------------
export class FloatingActionButton extends React.PureComponent<FloatingActionButtonProps> {
    constructor(props: FloatingActionButtonProps) {
        super(props);
    }
    render() {
        let iconPadding = Math.floor(this.props.diameter * 0.3 / 2);
        return <div
            style={{
                width: this.props.diameter,
                height: this.props.diameter,
                backgroundColor: this.props.backgroundColor,
                fontSize: Math.floor(this.props.diameter * 5 / 7) + "px",
                lineHeight: this.props.diameter + "px",
                ...this.props.style
            }}
            className="yodiwo-floating-action-button"
            onClick={this.props.onClick}
            onMouseDown={this.props.onMouseDown}
        >
            <div>
                {
                    React.Children.map(this.props.children, (child: React.ReactElement<any>, i) => <child.type
                        {...child.props}
                        style={{
                            width: this.props.diameter,
                            height: this.props.diameter,
                            padding: iconPadding,
                            color: this.props.iconColor
                        }}
                    />)
                }
            </div>
        </div >;
    }
}
// -------------------------------------------------------------------------------------------------------